import React, { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { motion } from 'framer-motion';
import 'bootstrap/dist/css/bootstrap.min.css';

const FAQSection = () => {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const faqs = [
    {
      question: "What is NetSuite ERP?",
      answer: "NetSuite ERP is a unified cloud business management suite that includes enterprise resource planning (ERP), accounting, CRM, ecommerce, inventory management, and more—all in a single system."
    },
    {
      question: "How does NetSuite Cloud-Based ERP differ from On-Premises ERP Systems?",
      answer: "NetSuite's cloud-based ERP offers real-time data access from anywhere, automatic updates, lower upfront costs, and eliminates the need for maintaining physical servers—unlike traditional on-premises systems."
    },
    {
        question: "What modules are included in NetSuite Cloud-Based ERP?",
        answer: "Core modules include Financial Management, Order Management, Production Management, Supply Chain Management, Warehouse Management, Procurement, and Human Capital Management, with optional add-ons available."
      },
      {
        question: "Which sectors does NetSuite ERP cater to?",
        answer: "NetSuite serves industries including retail, manufacturing, wholesale distribution, software, services, nonprofit, healthcare, and professional services with specialized solutions for each vertical."
      },
      {
        question: "Can NetSuite be customized to fit specific business needs?",
        answer: "Yes, NetSuite offers extensive customization capabilities through SuiteScript, SuiteFlow, SuiteBuilder, and SuiteTalk to tailor workflows, fields, forms, records, and reports to your exact requirements."
      },
      {
        question: "Is NetSuite suitable for Small Businesses/SME or MSME?",
        answer: "Absolutely. NetSuite offers scalable solutions that grow with your business, with pricing and features designed to meet the needs of small to midsize enterprises while supporting enterprise-level growth."
      },
      {
        question: "Can Oracle NetSuite integrate with other applications?",
        answer: "Yes, NetSuite provides robust integration capabilities with hundreds of pre-built connectors and an open API (SuiteTalk) for custom integrations with virtually any third-party application."
      },
      {
        question: "What is the implementation time for Oracle NetSuite?",
        answer: "Implementation typically ranges from 3-6 months depending on business complexity, with our accelerated implementation methodology ensuring rapid time-to-value without compromising quality."
      }
    // ... other FAQ items
  ];

  return (
    <section className="py-5 bg-light">
      <Container>
        <Row className="justify-content-center mb-5">
          <Col lg={8} className="text-center">
            <motion.h2
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              className="display-5 fw-bold mb-3"
            >
              Frequently Asked Questions
            </motion.h2>
            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.2, duration: 0.5 }}
              className="lead text-muted"
            >
              Get answers to common questions about NetSuite implementation
            </motion.p>
          </Col>
        </Row>

        <Row className="justify-content-center">
          <Col lg={8}>
            <div className="faq-container">
              {faqs.map((faq, index) => (
                <motion.div
                  key={index}
                  className="faq-item mb-3"
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.1, duration: 0.4 }}
                  onMouseEnter={() => setHoveredIndex(index)}
                  onMouseLeave={() => setHoveredIndex(null)}
                >
                  <motion.div
                    className="faq-question p-4 bg-white rounded shadow-sm"
                    whileHover={{ 
                      backgroundColor: '#f8f9fa',
                      transition: { duration: 0.2 }
                    }}
                  >
                    <div className="d-flex justify-content-between align-items-center">
                      <h5 className="mb-0 fw-semibold">{faq.question}</h5>
                      <motion.span
                        className="fs-4"
                        animate={{ 
                          rotate: hoveredIndex === index ? 45 : 0,
                          color: hoveredIndex === index ? '#0d6efd' : '#6c757d'
                        }}
                      >
                        +
                      </motion.span>
                    </div>
                  </motion.div>

                  <motion.div
                    className="faq-answer overflow-hidden"
                    initial={{ height: 0, opacity: 0 }}
                    animate={{
                      height: hoveredIndex === index ? 'auto' : 0,
                      opacity: hoveredIndex === index ? 1 : 0,
                    }}
                    transition={{ duration: 0.3, ease: 'easeInOut' }}
                  >
                    <div className="p-4 bg-white rounded-bottom shadow-sm">
                      <p className="text-secondary mb-0">{faq.answer}</p>
                    </div>
                  </motion.div>
                </motion.div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default FAQSection;